module.exports = __webpack_public_path__ + "img/b.cb5d0bfe.jpg";